export const encodeApiPathSegment = (
  value: string | null | undefined,
  label = "id"
): string => {
  const trimmed = (value ?? "").trim();

  if (!trimmed) {
    throw new Error(`A valid ${label} is required`);
  }

  return encodeURIComponent(trimmed);
};
